<template>
  <error :headline="headline">
    <template slot="image">
      <img alt="exclamation" src="../../assets/images/proj-help.svg"/>
    </template>
    <template slot="message">
      <p>The page has returned an error and will not continue</p>
    </template>
  </error>
</template>

<script>
  import Error from '@/component/Error';

  export default {
    name: 'ErrorPage',

    components: {
      Error,
    },

    data: function () {
      return {
        headline: 'Uh oh!',
      }
    },

    mounted: function () {
      this.interval = setTimeout(() => {
        this.$router.push({name: 'home'});
      }, 15000)
    },

    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval);
      next();
    }
  };
</script>
